import React, { useEffect, useState, useCallback, useMemo, useRef } from 'react';
import { isEmpty } from 'lodash';
import moment from 'moment';
import './Supplier.css';
import { connect, useSelector } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroll-component';
import { TFunction, useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { BombiixSortButton } from '../../Components/BombiixSortButton';
import SupplierOverviewCard from '../../Components/Card/SupplierOverviewCard.js/SupplierOverviewCard';
import type { SupplierOverviewItem } from '../../Components/Card/SupplierOverviewCard.js/SupplierOverviewCard';
import {
  deleteSupplier,
  fetchSupplierListAction,
  fetchSingleSupplierDetailsAction,
  supplierSuggestSwitchAction,
  integrateSupplierAction,
  sendFactoryUpdateLink as _sendFactoryUpdateLink,
  downloadSupplierSampleTemplateAction as _downloadSupplierSampleTemplateAction,
  exportSelectedSuppliersAction as _exportSelectedSuppliersAction,
  exportAllSuppliersAction as _exportAllSuppliersAction,
  fetchSuppliersTags as _fetchSuppliersTags,
  uploadSupplierFileToS3 as _uploadSupplierFileToS3,
} from './store/Supplier.action';
import DeintegrateSupplier from './DeintegrateSupplier';
import _BtnFilter from '../../Components/Utility/FilterAction/BtnFilter';
import { getPartnerOverviewCustomAttributes as _getPartnerOverviewCustomAttributes } from '../SystemMasters/Store/SystemMasters.action';
import _BtnClock from '../../Components/Utility/FilterAction/BtnClock';
import { CountriesList, Page_Size as defaultPageSize, createOptions } from '../../Components/helper';
import { getProductAssociatesAction } from '../Library/BomType/Store/BomType.action';
import Loader from '../../Components/Utility/Loader/Loader';
import { useComponent } from '../UserSetting/UsersLibrary/UserRights';
import { toasterMsg } from '../../Components/Toaster/Toaster';
import _CustomTooltip from '../../Components/Tooltip/CustomTooltip';
import CommonTabSwitch from '../../Components/CommonTabSwitch/CommonTabSwitch';
import { NewSearch } from '../../Components/PIM/common/NewSearch';
import { Floaty, FloatyButton, FloatyGroup } from '../../Components/Floaty';
import { AddIcon, DownloadIcon, UploadIcon } from '../../bombiix-icon';
import { NewCheckbox } from '../../Components/PIM/common/NewCheckbox';
import { AppDispatch, useAppDispatch } from '../../hooks/useAppDispatch';
import { BombiixModal } from '../../Components/BombiixModal';
import _UploadFileAndDocument from '../../Components/UploadFileAndDocument/UploadFileAndDocument';

type Fn<TArgs extends unknown[], TResult> = (...args: TArgs) => TResult;
type Thunk<TResult> = Fn<[dispatch: AppDispatch], Promise<TResult>>;
type PartnerOverviewT = TFunction<string[]>;
type CheckActionPermissionFn = Fn<[rights: unknown, section: string, module?: string, action?: string], boolean>;

/**
 * A product or component type offered by the filter and shown on the cards.
 */
interface ProductComponentOption {
  label: string;
  value: string;
  tier?: string | undefined;
  isActive?: boolean | undefined;
}

interface TagOption {
  label?: string;
  value?: unknown;
}

/**
 * One entry of the sort menu. `sort` is the direction the API payload expects.
 */
interface SupplierSortOption {
  value: string;
  sort: 'Asc' | 'Desc';
  propertyName: string;
  label: string;
}

interface SupplierListState {
  suppliersList: SupplierOverviewItem[];
  pageIndex: number;
  pageSize: number;
  hasMore: boolean;
  loading: boolean;
  totalRecords: number | null;
  searchText: string;
  multipaleFilters: boolean;
  searchLoaded: boolean;
  sortBy: SupplierSortOption | null;
  supplierType: Array<string | number> | undefined;
  productComponentTypeFilter: ProductComponentOption[];
  countryFilter: null;
  tagsOptions: TagOption[];
  supplierTagType: unknown[] | undefined;
  customAttributes: unknown[];
  isFilter: boolean;
  country?: string | null | undefined;
}

interface SupplierListQuery {
  pageIndex: number;
  pageSize: number;
  suppliersList?: SupplierOverviewItem[];
  totalRecords: number | null | undefined;
  searchText?: string;
  sortBy?: SupplierSortOption | null;
  country?: string | null | undefined;
  supplierType?: Array<string | number> | undefined;
  supplierTagType?: unknown[] | undefined;
  customAttributes?: unknown[];
  multipaleFilters?: boolean;
}

interface SupplierListRequest {
  pageIndex: number;
  pageSize: number;
  tierType: string;
  searchText?: string;
  sortOrder?: string;
  sortPropertyName?: string;
  country?: string;
  supplierType?: Array<string | number>;
  supplierTagType?: unknown[];
  customAttributes?: string;
}

interface StoredSupplierFilter {
  country?: string | null;
  supplierType?: Array<string | number>;
  supplierTagType?: unknown[];
  productComponentType?: ProductComponentOption[];
  filterVersion?: number;
  customAttributes?: CustomAttributeQueryEntry[];
  customAttributeSelections?: Record<string, CustomAttributeFilterOption[]>;
}

interface FilterFormData {
  productComponentType?: ProductComponentOption[];
  selectSupplierTag?: TagOption[];
  country?: { label?: string } | null;
}

interface SuggestSwitchPayload {
  supplierId: string | undefined;
  type: string;
  autoApproved?: boolean;
  canSuggest?: boolean;
}

interface OwnProps {}

interface StateProps {
  suppliersList: unknown;
  userInfo: { userId?: string };
  allSupplierTags: unknown;
}

interface DispatchProps {
  delete_supplier: Fn<[supplierId: string | null | undefined, user: { userId: string | undefined }, transactionMsg: PartnerOverviewT], Promise<unknown>>;
  getProductAssociatesAction: Fn<
    [params: { tier: string }],
    Promise<{ data?: Array<{ name: string; _id: string; tier?: string; isActive?: boolean }> } | undefined>
  >;
  fetchSupplierListAction: Fn<[params: SupplierListRequest], Promise<{ data?: { doc?: unknown; totalCount?: unknown } } | undefined>>;
  fetchSingleSupplierDetailsAction: Fn<[id: string], Promise<unknown>>;
  supplierSuggestSwitchAction: Fn<[id: string | undefined, payload: SuggestSwitchPayload, transactionMsg: PartnerOverviewT], Promise<unknown>>;
  integrateSupplierAction: Fn<
    [payload: { email: string | undefined; loggedInUserId: string | undefined; supplierId: string | undefined }, transactionMsg: PartnerOverviewT],
    Promise<unknown>
  >;
}

interface SupplierStoreState {
  Users: { logInRights?: unknown };
  SuppliersDetails: { suppliersList?: unknown; allSupplierTags?: unknown };
  UserDetails: { userInfo: { userId?: string } };
}

type SupplierProps = OwnProps & StateProps & DispatchProps;

interface UploadDocumentHandle {
  selectedDocument?: () => { document?: File } | false | undefined;
}

interface CustomAttributeFilterOption {
  label: string;
  value: string;
}

interface PartnerFilterAttribute {
  _id: string;
  keyName: string;
  aliasName?: string;
  type: string;
  options?: Array<{ _id: string; keyName: string; isActive?: boolean }>;
}

interface CustomAttributeFilterChange {
  colId: string;
  values: CustomAttributeFilterOption[];
}

interface CustomAttributeQueryEntry {
  colId: string;
  valueIds: string[];
}

const CustomTooltip = _CustomTooltip as unknown as React.FC<{ tooltipText: React.ReactNode; placement?: string; children?: React.ReactNode }>;
const BtnFilter = _BtnFilter as unknown as React.FC<{
  val: string | null | undefined;
  countriesList: Array<{ label: string }>;
  productComponentCollection: ProductComponentOption[];
  onApplyFilter: Fn<[data: FilterFormData], Promise<boolean | undefined>>;
  onResetFilter: () => Promise<void>;
  multipaleFilters: boolean;
  filterOnChange: Fn<[filterType: string, val: unknown], void>;
  selectedCountry: { label?: string | undefined } | null;
  productComponentType: ProductComponentOption[] | undefined;
  tagsOptions: TagOption[];
  selectSupplierTag: TagOption[];
  isFilter: boolean;
  customAttributes: PartnerFilterAttribute[];
  customAttributeFilters: Record<string, CustomAttributeFilterOption[]>;
}>;
const BtnClock = _BtnClock as unknown as React.FC<{
  isDisabled: boolean;
  isBulk: boolean;
  onIntervalChange: Fn<[option: { value: string }], void>;
  intervalTime: string | undefined;
  onSubmitRequest: () => void;
  btnClass: string;
  iconSize: number;
  loading: boolean;
  dropdownUp: boolean;
}>;
const UploadFileAndDocument = _UploadFileAndDocument as unknown as React.ForwardRefExoticComponent<
  {
    acceptedFileExtenstion: string;
    showTitleField: boolean;
    variant: 'asset' | 'default';
  } & React.RefAttributes<UploadDocumentHandle>
>;

const getPartnerOverviewCustomAttributes = _getPartnerOverviewCustomAttributes as unknown as Fn<
  [params: Record<string, unknown>],
  Thunk<PartnerFilterAttribute[] | null | undefined>
>;
const fetchSuppliersTags = _fetchSuppliersTags as unknown as () => Thunk<unknown>;
const sendFactoryUpdateLink = _sendFactoryUpdateLink as unknown as Fn<[dataObj: Record<string, unknown>, transactionMsg: PartnerOverviewT], Thunk<unknown>>;
const exportAllSuppliersAction = _exportAllSuppliersAction as unknown as Fn<
  [params: Record<string, unknown>, transactionMsg: PartnerOverviewT],
  Thunk<unknown>
>;
const exportSelectedSuppliersAction = _exportSelectedSuppliersAction as unknown as Fn<
  [ids: Array<string | undefined>, tier: string, transactionMsg: PartnerOverviewT],
  Thunk<unknown>
>;
const downloadSupplierSampleTemplateAction = _downloadSupplierSampleTemplateAction as unknown as Fn<
  [transactionMsg: PartnerOverviewT, params: { tierType: string }],
  Thunk<unknown>
>;
const uploadSupplierFileToS3 = _uploadSupplierFileToS3 as unknown as Fn<[file: File, tier: string], Thunk<{ success?: boolean; message?: string } | undefined>>;

const MONTHLY_INTERVALS = ['3', '6', '9'];

/**
 * Partner Overview listing: tier tabs, search / filter / sort, the partner card
 * grid with infinite scroll, bulk factory-link requests and the import / export
 * actions.
 *
 * The sort control's option type names the direction `sortOrder`, while these
 * options (and the API payload built from them) use `sort`, so the direction is
 * mapped in for display and the ORIGINAL option object is handed back on change —
 * the request body stays byte-for-byte what it was. Download stays available with
 * nothing selected: its menu offers a sample template and a full export alongside
 * the selected-rows option, and each entry gates itself. Send-Factory-Link acts on
 * the current selection, so it keeps the recessed well that greys out while
 * nothing is selected (Figma node 11654:1224744). The tier tabs and Select All sit
 * outside the scrolling region so they stay put while only the cards move.
 * @param {object} props - Component props.
 * @returns {React.ReactElement} The listing page.
 */
function Supplier({
  allSupplierTags,
  delete_supplier: deleteSupplierProp,
  getProductAssociatesAction: getProductAssociatesProp,
  fetchSupplierListAction: fetchSupplierListProp,
  supplierSuggestSwitchAction: supplierSuggestSwitchProp,
  integrateSupplierAction: integrateSupplierProp,
  userInfo,
}: SupplierProps) {
  const { t } = useTranslation(['modules/partner-overview', 'common']);
  const history = useHistory();
  const dispatch = useAppDispatch();
  const storedTier = localStorage.getItem('SupplierSelectedTier');
  const initialTier = storedTier || 'Tier1';
  const [state, setState] = useState<SupplierListState>({
    suppliersList: [],
    pageIndex: 1,
    pageSize: defaultPageSize,
    hasMore: true,
    loading: true,
    totalRecords: null,
    searchText: '',
    multipaleFilters: false,
    searchLoaded: false,
    sortBy: null,
    supplierType: [],
    productComponentTypeFilter: [],
    countryFilter: null,
    tagsOptions: [],
    supplierTagType: [],
    customAttributes: [],
    isFilter: false,
  });
  const [actionState, setActionState] = useState({
    downloadLoading: false,
    showUploadModal: false,
    showErrModal: false,
    importLoading: false,
    filesSelected: null,
    totalRecordsToUpload: 0,
    errorRecordCount: 0,
    successRecordCount: 0,
    errFile: '',
  });

  const [showDeintegrate, setShowDeintegrate] = useState(false);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [deletedSupplierId, setDeletedSupplierId] = useState<string | null | undefined>(null);
  const countriesList = CountriesList.map((item) => ({ label: item }));
  const [productComponentCollection, setProductComponentCollection] = useState<ProductComponentOption[]>([]);
  const [mailIconStatus, setMailIconStatus] = useState(false);

  const [selectedCountry, setSelectedCountry] = useState<{ label?: string | undefined } | null>(null);
  const [productComponentType, setProductComponentType] = useState<ProductComponentOption[] | undefined>([]);
  const [selectSupplierTag, setSelectSupplierTag] = useState<TagOption[]>([]);
  const [selectedIdArray, setSelectedIdArray] = useState<Array<string | undefined>>([]);
  const [intervalTime, setIntervalTime] = useState<string | undefined>();
  const [loading, setLoading] = useState(false);
  const [tierLoading, setTierLoading] = useState(false);
  const [selectedTier, setSelectedTier] = useState(initialTier);

  const ProductTestingData = useSelector((redState: SupplierStoreState) => redState);
  const { Users } = ProductTestingData;
  const { logInRights } = Users;
  const CheckActionPermission = useComponent().CheckActionPermission as unknown as CheckActionPermissionFn;
  const refreshTierRef = useRef<{ selectedTier: string; sortBy: SupplierSortOption | null; refreshPage: (() => Promise<void>) | null }>({
    selectedTier,
    sortBy: state.sortBy,
    refreshPage: null,
  });
  const loadNextPageRef = useRef<(() => Promise<void>) | null>(null);
  const downloading = 'COMMON_LABEL.DOWNLOADING';

  const CostingAddEditAccess = CheckActionPermission(logInRights, 'supplierOverview', 'all', 'addEdit');

  const CostingDeleteAccess = CheckActionPermission(logInRights, 'supplierOverview', 'all', 'delete');

  const filteredProductComponentCollection = useMemo(() => {
    if (!selectedTier || !productComponentCollection?.length) {
      return productComponentCollection;
    }
    return productComponentCollection?.filter((item) => item?.tier === selectedTier && item?.isActive);
  }, [selectedTier, productComponentCollection]);

  useEffect(() => {
    setState((prev) => ({
      ...prev,
      tagsOptions: createOptions<TagOption>(allSupplierTags, 'label', 'value', true),
    }));
  }, [allSupplierTags]);

  const [filterCustomAttributes, setFilterCustomAttributes] = useState<PartnerFilterAttribute[]>([]);
  const [customAttributeFilters, setCustomAttributeFilters] = useState<Record<string, CustomAttributeFilterOption[]>>({});

  useEffect(() => {
    let cancelled = false;
    const loadFilterAttributes = async () => {
      const list = await dispatch(getPartnerOverviewCustomAttributes({ isActive: true, appliesTo: 'supplier', tierType: selectedTier }));
      if (!cancelled) setFilterCustomAttributes(list ?? []);
    };
    loadFilterAttributes();
    return () => {
      cancelled = true;
    };
  }, [dispatch, selectedTier]);

  const filterOnChange = (filterType: string, val: unknown) => {
    if (filterType === 'country') {
      setSelectedCountry(val as { label?: string } | null);
    }
    if (filterType === 'productType') {
      setProductComponentType(val as ProductComponentOption[]);
    }
    if (filterType === 'supplierTag') {
      setSelectSupplierTag(val as TagOption[]);
    }
    if (filterType === 'customAttribute') {
      const { colId, values } = val as CustomAttributeFilterChange;
      setCustomAttributeFilters((previous) => ({ ...previous, [colId]: values }));
    }
  };

  const TIER_TABS = useMemo(
    () => [
      { eventKey: 'Tier1', eventName: t('SUPPLIER_OVERVIEW.TIER_1') },
      { eventKey: 'Tier2', eventName: t('SUPPLIER_OVERVIEW.TIER_2') },
      { eventKey: 'Tier3', eventName: t('SUPPLIER_OVERVIEW.TIER_3') },
      { eventKey: 'Tier4', eventName: t('SUPPLIER_OVERVIEW.TIER_4') },
    ],
    [t],
  );

  const handleTierChange = (tier: string) => {
    setTierLoading(true);
    setSelectedTier(tier);
    localStorage.setItem('SupplierSelectedTier', tier);
    setSelectedCountry(null);
    setProductComponentType([]);
    setSelectSupplierTag([]);
    setCustomAttributeFilters({});
    setState((prev) => ({
      ...prev,
      sortBy: null,
      country: null,
      supplierType: [],
      supplierTagType: [],
      customAttributes: [],
      searchText: '',
      searchLoaded: false,
      isFilter: false,
    }));

    if ((productComponentType?.length ?? 0) > 0) {
      const validTypesForNewTier = (productComponentType ?? []).filter((selectedType) => {
        const productType = productComponentCollection.find((item) => item.value === selectedType.value);
        return productType && productType.tier === tier;
      });

      if (validTypesForNewTier.length !== productComponentType?.length) {
        setProductComponentType(validTypesForNewTier);
        setState((prev) => ({
          ...prev,
          productComponentTypeFilter: validTypesForNewTier,
        }));
      }
    }

    setTimeout(() => setTierLoading(false), 100);
  };

  const handleDeintegrateClose = () => {
    setShowDeintegrate(false);
  };

  const closeConfirmationsPopup = () => {
    setShowConfirmationPopup(false);
    setDeletedSupplierId(null);
  };

  /**
   * Loads one page of partners for the current tier and appends it. Stops paging
   * once everything the server reported has been loaded.
   * @param {SupplierListQuery} data - Paging, search, sort and filter state.
   */
  const getSupplierList = async (data: SupplierListQuery) => {
    const loadedCount = data?.suppliersList?.length;
    if (data?.totalRecords !== null && data?.totalRecords !== undefined && loadedCount !== undefined && loadedCount >= data.totalRecords) {
      setState((prev) => ({
        ...prev,
        hasMore: false,
      }));
      return;
    }

    setState((prev) => ({
      ...prev,
      loading: true,
    }));
    const params: SupplierListRequest = {
      pageIndex: data.pageIndex,
      pageSize: data.pageSize,
      tierType: selectedTier,
    };
    if (data.searchText) {
      params.searchText = data.searchText;
    }
    if (data.sortBy) {
      params.sortOrder = data.sortBy.sort;
      params.sortPropertyName = data.sortBy.propertyName;
    }
    if (data.country) {
      params.country = data.country;
    }
    if (data.supplierType) {
      params.supplierType = data.supplierType;
    }

    if (data.supplierTagType) {
      params.supplierTagType = data.supplierTagType;
    }

    if (Array.isArray(data.customAttributes) && data.customAttributes.length > 0) {
      params.customAttributes = JSON.stringify(data.customAttributes);
    }

    const res = await fetchSupplierListProp(params);

    const pageSuppliers: SupplierOverviewItem[] = Array.isArray(res?.data?.doc) ? res.data.doc : [];
    const totalCount = typeof res?.data?.totalCount === 'number' ? res.data.totalCount : 0;
    const mergedSuppliers = [...(data?.suppliersList || []), ...pageSuppliers];

    setState((prev) => ({
      ...prev,
      suppliersList: mergedSuppliers,
      pageIndex: data.pageIndex + 1,
      loading: false,
      totalRecords: totalCount,
      hasMore: pageSuppliers.length > 0 && mergedSuppliers.length < totalCount,
    }));
  };

  const getSupplierTags = async () => {
    dispatch(fetchSuppliersTags());
  };

  const refreshPage = async () => {
    setState((stat) => ({
      ...stat,
      loading: true,
      pageIndex: 1,
      suppliersList: [],
      totalRecords: null,
      hasMore: true,
      searchLoaded: false,
    }));
    const params = {
      pageIndex: 1,
      pageSize: state.pageSize,
      suppliersList: [],
      totalRecords: null,
      searchText: state.searchText,
      sortBy: state.sortBy,
      country: state.country,
      supplierType: state.supplierType,
      supplierTagType: state.supplierTagType,
      customAttributes: state.customAttributes,
    };
    await getSupplierList(params);
  };

  refreshTierRef.current = { selectedTier, sortBy: state.sortBy, refreshPage };

  const handleSearch = async (e: { target: { value: string } }) => {
    const targetValue = e.target.value;
    setState((prev) => ({
      ...prev,
      searchText: targetValue,
      searchLoaded: true,
    }));
  };

  const handleNextPagesInScroll = async () => {
    const params = {
      pageIndex: state.pageIndex,
      pageSize: state.pageSize,
      searchText: state.searchText,
      sortBy: state.sortBy,
      suppliersList: state.suppliersList,
      totalRecords: state.totalRecords,
      country: state.country,
      supplierType: state.supplierType,
      supplierTagType: state.supplierTagType,
      customAttributes: state.customAttributes,
    };

    await getSupplierList(params);
  };

  loadNextPageRef.current = handleNextPagesInScroll;

  const firstExuit = useCallback(async () => {
    const proAsso = await getProductAssociatesProp({ tier: selectedTier });
    if (proAsso?.data) {
      const data = proAsso.data.map((item) => {
        return {
          label: item.name,
          value: item._id,
          tier: item.tier,
          isActive: item.isActive !== false,
        };
      });
      const sortedData = data.sort((a, b) => {
        return a.label.localeCompare(b.label);
      });
      setProductComponentCollection([...(sortedData || [])]);
    }
  }, [selectedTier, getProductAssociatesProp]);

  const handleSortBy = async (val: SupplierSortOption | null) => {
    setState((prev) => ({
      ...prev,
      sortBy: val,
      loading: true,
      pageIndex: 1,
      suppliersList: [],
      totalRecords: null,
      hasMore: true,
    }));
    const params = {
      pageIndex: 1,
      pageSize: state.pageSize,
      searchText: state.searchText,
      country: state.country,
      supplierType: state.supplierType,
      supplierTagType: state.supplierTagType,
      customAttributes: state.customAttributes,
      sortBy: val,
      suppliersList: [],
      totalRecords: null,
    };
    await getSupplierList(params);
  };

  /**
   * Reads the persisted filter for a tier. Filters saved before custom attributes existed have a
   * different shape, so anything without the current version is discarded rather than restored —
   * a stale shape would otherwise leave the panel showing chips it cannot clear.
   */
  function readStoredFilter(tier: string): StoredSupplierFilter | null {
    try {
      const raw = localStorage.getItem(`SupplierFilter_${tier}`);
      if (!raw) return null;
      const parsed: StoredSupplierFilter | null = JSON.parse(raw);
      if (parsed?.filterVersion !== 2) {
        localStorage.removeItem(`SupplierFilter_${tier}`);
        return null;
      }
      return parsed;
    } catch {
      localStorage.removeItem(`SupplierFilter_${tier}`);
      return null;
    }
  }

  /**
   * Restores the tier's persisted filter, including its custom-attribute selections, or loads the
   * first page unfiltered.
   */
  async function fetchSuppliersList() {
    const localstorageFilter = readStoredFilter(selectedTier);
    if (localstorageFilter) {
      setState((prevState) => ({
        ...prevState,
        country: localstorageFilter?.country,
        supplierType: localstorageFilter?.supplierType,
        supplierTagType: localstorageFilter?.supplierTagType,
        customAttributes: localstorageFilter?.customAttributes ?? [],
        multipaleFilters: true,
        isFilter: true,
      }));
      setCustomAttributeFilters(localstorageFilter?.customAttributeSelections ?? {});
      setSelectSupplierTag(createOptions<TagOption>(localstorageFilter?.supplierTagType, 'label', 'value', true));
      setProductComponentType(localstorageFilter?.productComponentType);

      if (localstorageFilter?.country !== null) {
        setSelectedCountry({ label: localstorageFilter?.country ?? undefined });
      }
      return;
    }

    setState((prev) => ({
      ...prev,
      loading: true,
      pageIndex: 1,
      suppliersList: [],
      totalRecords: null,
      hasMore: true,
    }));
    await getSupplierList({
      pageIndex: 1,
      pageSize: state.pageSize,
      suppliersList: [],
      totalRecords: null,
    });
  }

  useEffect(() => {
    firstExuit();
    fetchSuppliersList();
    getSupplierTags();
  }, []);

  useEffect(() => {
    firstExuit();
    fetchSuppliersList();
  }, [selectedTier]);

  useEffect(() => {
    const handleSupplierListRefresh = () => {
      refreshTierRef.current.refreshPage?.();
    };
    window.addEventListener('supplier-list-refresh', handleSupplierListRefresh);
    return () => {
      window.removeEventListener('supplier-list-refresh', handleSupplierListRefresh);
    };
  }, []);

  useEffect(() => {
    if (state.loading || !state.hasMore || state.suppliersList.length === 0) {
      return;
    }
    const scrollContainer = document.getElementById('scrollableContaier_suppliersList');
    if (scrollContainer && scrollContainer.scrollHeight <= scrollContainer.clientHeight) {
      loadNextPageRef.current?.();
    }
  }, [state.suppliersList.length, state.hasMore, state.loading]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      if (state.searchLoaded) {
        setState((prev) => ({
          ...prev,
          loading: true,
          pageIndex: 1,
          suppliersList: [],
          totalRecords: null,
          hasMore: true,
        }));
        const params = {
          pageIndex: 1,
          pageSize: state.pageSize,
          searchText: state.searchText,
          sortBy: state.sortBy,
          country: state.country,
          supplierType: state.supplierType,
          supplierTagType: state.supplierTagType,
          customAttributes: state.customAttributes,
          suppliersList: [],
          totalRecords: null,
        };
        await getSupplierList(params);
        setState((prev) => ({
          ...prev,
          loading: false,
        }));
      }
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
  }, [state.searchText]);

  useEffect(() => {
    const multifilter = async () => {
      if (state.multipaleFilters) {
        setState((prev) => ({
          ...prev,
          loading: true,
          pageIndex: 1,
          suppliersList: [],
          totalRecords: null,
          hasMore: true,
        }));

        const params = {
          pageIndex: 1,
          pageSize: state.pageSize,
          searchText: state.searchText,
          sortBy: state.sortBy,
          country: state.country,
          supplierType: state.supplierType,
          supplierTagType: state.supplierTagType,
          customAttributes: state.customAttributes,
          suppliersList: [],
          totalRecords: null,
          multipaleFilters: true,
        };

        await getSupplierList(params);
        setState((prev) => ({
          ...prev,
          loading: false,
          multipaleFilters: false,
        }));
      }
    };

    multifilter();
  }, [state.multipaleFilters]);

  const onResetFilter = async () => {
    if (localStorage.getItem(`SupplierFilter_${selectedTier}`)) {
      localStorage.removeItem(`SupplierFilter_${selectedTier}`);
    }
    setSelectedCountry(null);
    setProductComponentType([]);
    setSelectSupplierTag([]);
    setCustomAttributeFilters({});
    setState((prev) => ({
      ...prev,
      country: null,
      supplierType: [],
      supplierTagType: [],
      customAttributes: [],
      searchText: '',
      sortBy: null,
      searchLoaded: false,
      isFilter: false,
    }));

    const params = {
      pageIndex: 1,
      pageSize: state.pageSize,
      suppliersList: [],
      totalRecords: null,
    };
    await getSupplierList(params);
  };

  /**
   * Applies and persists the filter. A field the user never touched is absent from the form
   * payload rather than an empty array, so both list fields are normalised up front — reading
   * `.length` off an untouched Tag field used to throw.
   */
  const onApplyFilter = async (data: FilterFormData) => {
    const selectedProductTypes = data.productComponentType ?? [];
    const selectedTags = data.selectSupplierTag ?? [];
    const customAttributeQuery: CustomAttributeQueryEntry[] = Object.entries(customAttributeFilters)
      .filter(([, values]) => (values ?? []).length > 0)
      .map(([colId, values]) => ({ colId, valueIds: values.map((entry) => entry.value) }));
    if (
      selectedProductTypes.length === 0 &&
      (data.country === undefined || data.country === null) &&
      selectedTags.length === 0 &&
      customAttributeQuery.length === 0
    ) {
      return false;
    }

    const supplierTypesListIdArray = selectedProductTypes.map((item) => item?.value);
    const supplierNewTag = selectedTags.map((item) => item?.value);

    const filterObj: StoredSupplierFilter = {
      country: data.country?.label || null,
      supplierType: supplierTypesListIdArray,
      supplierTagType: supplierNewTag,
      productComponentType: selectedProductTypes,
      filterVersion: 2,
      customAttributes: customAttributeQuery,
      customAttributeSelections: customAttributeFilters,
    };
    localStorage.setItem(`SupplierFilter_${selectedTier}`, JSON.stringify(filterObj));
    setState((prev) => ({
      ...prev,
      country: data.country?.label || null,
      supplierType: supplierTypesListIdArray,
      supplierTagType: supplierNewTag,
      customAttributes: customAttributeQuery,
      multipaleFilters: true,
      isFilter: true,
    }));
    return undefined;
  };

  const deleteSupplierConfirmed = async () => {
    setState((prevState) => ({
      ...prevState,
      loading: true,
    }));
    const res = await deleteSupplierProp(deletedSupplierId, { userId: userInfo.userId }, t);
    if (res) {
      setShowConfirmationPopup(!showConfirmationPopup);
      refreshPage();
    } else {
      setState((preState) => ({
        ...preState,
        loading: false,
      }));
    }
  };

  const deleteSelectedSupplier = (id: string | undefined) => {
    setShowConfirmationPopup(!showConfirmationPopup);
    setDeletedSupplierId(id);
  };

  const onSuggestSwitchChange = async (e: React.ChangeEvent<HTMLInputElement>, id: string | undefined, type: 'supplierSuggest' | 'autoApproved') => {
    const value = e.target.checked;
    const suggestObj: SuggestSwitchPayload = {
      supplierId: id,
      type,
      ...(type === 'autoApproved' ? { autoApproved: value } : { canSuggest: value }),
    };
    const res = await supplierSuggestSwitchProp(id, suggestObj, t);
    if (res) {
      const patch = type === 'supplierSuggest' ? { canSuggest: value, ...(value ? {} : { autoApproved: false }) } : { autoApproved: value };
      const sup = state.suppliersList.map((option) => (option._id === id ? { ...option, ...patch } : option));
      setState({ ...state, suppliersList: sup });
    }
  };

  const integrateSupplier = async (obj: { id: string | undefined; email: string | undefined }) => {
    const integrateSupplierObj = {
      email: obj.email,
      loggedInUserId: userInfo.userId,
      supplierId: obj.id,
    };
    setMailIconStatus(true);
    const res = await integrateSupplierProp(integrateSupplierObj, t);
    if (res) {
      setMailIconStatus(false);
    }
  };

  const sortByOptions: SupplierSortOption[] = [
    {
      value: '111',
      sort: 'Asc',
      propertyName: 'code',
      label: t('SUPPLIER_OVERVIEW.CODE_ASCENDING'),
    },
    {
      value: '112',
      sort: 'Desc',
      propertyName: 'code',
      label: t('SUPPLIER_OVERVIEW.CODE_DESCENDING'),
    },
    {
      value: '113',
      sort: 'Asc',
      propertyName: 'country',
      label: t('SUPPLIER_OVERVIEW.COUNTRY_ASCENDING'),
    },
    {
      value: '114',
      sort: 'Desc',
      propertyName: 'country',
      label: t('SUPPLIER_OVERVIEW.COUNTRY_DESCENDING'),
    },
  ];

  const onSelectCheckBox = async (_e: React.ChangeEvent<HTMLInputElement>, id: string | undefined) => {
    let selectedItems = [...selectedIdArray];
    const findItems = selectedItems?.filter((item) => item === id);
    if (!isEmpty(findItems)) {
      selectedItems = selectedItems?.filter((item) => item !== id);
      setSelectedIdArray([...selectedItems]);
    } else {
      setSelectedIdArray([...selectedItems, id]);
    }
  };

  const onIntervalChange = (e: { value: string }) => {
    setIntervalTime(e.value);
  };

  const onSubmitRequest = async () => {
    const currentDate = moment();
    let futureDate;
    if (!intervalTime) {
      toasterMsg(t('SUPPLIER_OVERVIEW.PLEASE_SELECT_RECURRING_PERIOD'), t('SUPPLIER_OVERVIEW.DANGER'));
    } else {
      if (MONTHLY_INTERVALS.includes(String(intervalTime))) {
        futureDate = currentDate.add(Number(intervalTime), 'months');
      }
      const dataObj = {
        supplier: selectedIdArray,
        intervalTime,
        loggedInUserId: userInfo?.userId,
        endDate: futureDate ? futureDate.toISOString() : null,
      };
      setLoading(true);
      const res = await dispatch(sendFactoryUpdateLink(dataObj, t));
      setLoading(false);
      if (res) {
        setSelectedIdArray([]);
        refreshPage();
      }
    }
  };

  const [uploadLoading, setUploadLoading] = useState(false);
  const uploadDocRef = useRef<UploadDocumentHandle | null>(null);

  const handleSupplierUploadOpen = () => {
    setActionState((prev) => ({ ...prev, showUploadModal: true }));
  };

  const closeUploadModal = () => {
    setActionState((prev) => ({ ...prev, showUploadModal: false }));
  };

  const handleUploadConfirm = async () => {
    const uploadedFile = uploadDocRef.current?.selectedDocument?.();
    if (!uploadedFile || !uploadedFile.document) {
      return;
    }
    const file = uploadedFile.document;
    const maxSize = 500 * 1024 * 1024;
    if (file.size > maxSize) {
      toasterMsg(t('File size exceeds 500MB limit'), 'danger');
      return;
    }
    const validMimeTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'];
    const fileName = (file.name || '').toLowerCase();
    const hasValidExtension = fileName.endsWith('.xlsx') || fileName.endsWith('.xls');
    const hasValidMime = validMimeTypes.includes(file.type);
    if (!hasValidMime && !hasValidExtension) {
      toasterMsg(t('Invalid file type. Please select .xlsx or .xls file'), 'danger');
      return;
    }
    setUploadLoading(true);
    toasterMsg(t('SUPPLIER_OVERVIEW.UPLOADING_SUPPLIER_FILE'), 'success');
    try {
      const result = await dispatch(uploadSupplierFileToS3(file, selectedTier));
      if (result?.success) {
        toasterMsg(t('SUPPLIER_OVERVIEW.UPLOAD_STARTED_NOTIFY'), 'success');
        closeUploadModal();
      } else {
        toasterMsg(result?.message ?? t('SUPPLIER_OVERVIEW.UPLOAD_FAILED'), 'danger');
      }
    } catch (error) {
      toasterMsg(t('SUPPLIER_OVERVIEW.UPLOAD_FAILED'), 'danger');
    } finally {
      setUploadLoading(false);
    }
  };

  const downloadExcelSheet = async (type: 'All' | 'selected' | 'Sample') => {
    setActionState((prev) => ({ ...prev, downloadLoading: true }));

    try {
      if (type === 'All') {
        const params = {
          tierType: selectedTier,
          searchText: state.searchText || '',
          countryFilter: state.country || '',
          supplierTypeFilter: state.supplierType?.join(',') || '',
          supplierTagType: state.supplierTagType ?? [],
          customAttributes: state.customAttributes.length > 0 ? JSON.stringify(state.customAttributes) : '',
        };
        await dispatch(exportAllSuppliersAction(params, t));
      } else if (type === 'selected') {
        await dispatch(exportSelectedSuppliersAction(selectedIdArray, selectedTier, t));
      } else if (type === 'Sample') {
        const params = {
          tierType: selectedTier,
        };
        await dispatch(downloadSupplierSampleTemplateAction(t, params));
      }
    } catch (error) {
      toasterMsg(t('BACKEND_SERVER.SUPPLIER_SERVICE.SOMETHING_WANT_WRONG'), 'danger');
    } finally {
      setActionState((prev) => ({ ...prev, downloadLoading: false }));
    }
  };
  const renderDownloadPopover = () => {
    return (
      <ul>
        <li>
          <button className="p-0 btn" type="button" onClick={() => downloadExcelSheet('Sample')} disabled={actionState?.downloadLoading}>
            {actionState?.downloadLoading ? t(downloading) : t('SUPPLIER_OVERVIEW.DOWNLOAD_SAMPLE_FILE')}
          </button>
        </li>
        <li>
          <button
            className="p-0 btn"
            type="button"
            disabled={isEmpty(selectedIdArray) || actionState?.downloadLoading}
            onClick={() => downloadExcelSheet('selected')}
          >
            {actionState.downloadLoading ? t(downloading) : t('SUPPLIER_OVERVIEW.DOWNLOAD_SELECTED_SUPPLIERS')}
          </button>
        </li>
        <li>
          <button
            type="button"
            disabled={isEmpty(state?.suppliersList) || actionState?.downloadLoading}
            onClick={() => downloadExcelSheet('All')}
            className={actionState.downloadLoading ? 'disabled-btn p-0 btn' : 'p-0 btn'}
          >
            {actionState.downloadLoading ? t(downloading) : t('SUPPLIER_OVERVIEW.DOWNLOAD_ALL_SUPPLIERS')}
          </button>
        </li>
      </ul>
    );
  };

  const visibleSupplierIds = (state.suppliersList || []).map((supplier) => supplier?._id).filter(Boolean);
  const isAllSelected = visibleSupplierIds.length > 0 && visibleSupplierIds.every((id) => selectedIdArray.includes(id));

  /**
   * @description Selects or clears every partner currently loaded in the tier.
   * Only the loaded page is affected, which is what the checkbox beside the grid represents.
   */
  const handleSelectAll = () => {
    setSelectedIdArray(isAllSelected ? [] : visibleSupplierIds);
  };

  return (
    <>
      <div className="page-title-filter sticky">
        <div className="title-container">
          <h4 className="title">
            {t('PARTNER_OVERVIEW.PARTNER_OVERVIEW')}
            {t('PARTNER_OVERVIEW.SUPPLIERS')}
          </h4>
        </div>
        <div className="action-icons-container">
          <NewSearch
            className="bombiix-search"
            value={state?.searchText ?? ''}
            onChange={(value) => handleSearch({ target: { value } })}
            placeholder={t('SUPPLIER_OVERVIEW.SEARCH_SUPLIER')}
            ariaLabel={t('SUPPLIER_OVERVIEW.SEARCH_SUPLIER')}
            width={200}
          />
          <BtnFilter
            val={state.country}
            countriesList={countriesList}
            productComponentCollection={filteredProductComponentCollection}
            onApplyFilter={onApplyFilter}
            onResetFilter={onResetFilter}
            multipaleFilters={state.multipaleFilters}
            filterOnChange={filterOnChange}
            selectedCountry={selectedCountry}
            productComponentType={productComponentType}
            tagsOptions={state.tagsOptions}
            selectSupplierTag={selectSupplierTag}
            isFilter={state?.isFilter}
            customAttributes={filterCustomAttributes}
            customAttributeFilters={customAttributeFilters}
          />
          <BombiixSortButton
            options={sortByOptions.map((option) => ({ ...option, sortOrder: option.sort }))}
            value={state.sortBy ? { ...state.sortBy, sortOrder: state.sortBy.sort } : null}
            onChange={(selected) =>
              handleSortBy(selected ? sortByOptions.find((option) => option.value === ('value' in selected ? selected.value : undefined)) ?? null : null)
            }
            sortByLabel={t('BTN_SORT.SORT_BY', { ns: 'common' })}
            ariaLabel={t('BTN_SORT.SORT', { ns: 'common' })}
          />
        </div>
        <Floaty position="fixed">
          {CostingAddEditAccess && (
            <FloatyButton icon={AddIcon} label={t('SUPLIER.ADD_EDIT_SUPPLIER_OVERVIEW.ADD_SUPPLIER')} onClick={() => history.push('/suppliers/add')} />
          )}
          {CostingAddEditAccess && <FloatyButton icon={UploadIcon} label={t('SUPPLIER_OVERVIEW.UPLOAD')} onClick={handleSupplierUploadOpen} />}
          <OverlayTrigger
            placement="top"
            trigger="click"
            rootClose
            overlay={
              <Popover id="supplier-download-menu" className="custom-popover file-download-popover">
                <Popover.Content>{renderDownloadPopover()}</Popover.Content>
              </Popover>
            }
          >
            <FloatyButton icon={DownloadIcon} label={t('COMMON_LABEL.DOWNLOAD')} showTooltip={false} />
          </OverlayTrigger>
          <FloatyGroup disabled={isEmpty(selectedIdArray)}>
            <CustomTooltip placement="top" tooltipText={t('BTN_CLOCK.SEND_FACTORY_LINK', { ns: 'common' })}>
              <BtnClock
                isDisabled={isEmpty(selectedIdArray)}
                isBulk
                onIntervalChange={onIntervalChange}
                intervalTime={intervalTime}
                onSubmitRequest={onSubmitRequest}
                btnClass="bombiix-icon-container"
                iconSize={28}
                loading={loading}
                dropdownUp
              />
            </CustomTooltip>
          </FloatyGroup>
        </Floaty>
      </div>
      <div className="px-4 partner-tab-bar">
        <div className="d-flex justify-content-between align-items-center partner-tab-row">
          <CommonTabSwitch masterActiveTab={selectedTier} MenuList={TIER_TABS} activeTheTab={handleTierChange} />
          <NewCheckbox
            id="selectAllPartners"
            name="selectAllPartners"
            checked={isAllSelected}
            disabled={visibleSupplierIds.length === 0}
            label={t('SUPPLIER_OVERVIEW.SELECT_ALL')}
            onChange={handleSelectAll}
          />
        </div>
      </div>
      <div id="scrollableContaier_suppliersList" className="sticky-header-inner-scroll partner-list-scroll">
        <div>
          <InfiniteScroll
            dataLength={state.suppliersList.length}
            next={() => handleNextPagesInScroll()}
            hasMore={state.hasMore}
            scrollableTarget="scrollableContaier_suppliersList"
            loader={state.loading && !tierLoading && <Loader />}
          >
            <div className="px-4">
              {tierLoading ? (
                <div className="d-flex justify-content-center align-items-center supplier-list-empty">
                  <Loader />
                </div>
              ) : (
                <>
                  <div className="partner-card-grid">
                    {state.suppliersList.map((item, i) => (
                      <SupplierOverviewCard
                        key={item?._id}
                        productComponentCollection={productComponentCollection}
                        item={item}
                        index={i}
                        fetchSuppliersList={fetchSuppliersList}
                        onDelete={(id) => {
                          deleteSelectedSupplier(id);
                        }}
                        onSuggestSwitchChange={onSuggestSwitchChange}
                        integrateSupplier={integrateSupplier}
                        CostingAddEditAccess={CostingAddEditAccess}
                        CostingDeleteAccess={CostingDeleteAccess}
                        mailIconStatus={mailIconStatus}
                        selectedIds={selectedIdArray}
                        onCheck={onSelectCheckBox}
                        refreshPage={refreshPage}
                        selectedTier={selectedTier}
                      />
                    ))}
                  </div>
                  {!state.loading && state.suppliersList?.length === 0 && (
                    <div className="w-100 text-center mt-4">
                      <h6>{t('SUPPLIER_OVERVIEW.NO_RECORDS_FOUND')}</h6>
                    </div>
                  )}
                </>
              )}
            </div>
          </InfiniteScroll>
        </div>
      </div>

      {showConfirmationPopup && (
        <BombiixModal
          show={showConfirmationPopup}
          size="sm"
          title={t('SUPPLIER_OVERVIEW.DELETE_SUPPLIER_TITLE')}
          onClose={closeConfirmationsPopup}
          onSave={deleteSupplierConfirmed}
          saveLabel={t('COMMON_LABEL.DELETE', { ns: 'common' })}
          saveVariant="red"
          saveLoading={state.loading}
        >
          <div className="bombiix-modal__confirm-body">
            <p className="mb-0 text-center">{t('SUPPLIER_OVERVIEW.DELETE_SUPPLIER_MESSAGE')}</p>
          </div>
        </BombiixModal>
      )}

      {showDeintegrate && (
        <DeintegrateSupplier
          show={showDeintegrate}
          handleClose={handleDeintegrateClose}
          handleConfirm={() => {
            return false;
          }}
        />
      )}

      <BombiixModal
        size="lg"
        show={actionState.showUploadModal}
        title={t('SUPPLIER_DOCUMENTS.UPLOAD_FILE')}
        onClose={closeUploadModal}
        onSave={handleUploadConfirm}
        saveLabel={t('COMMON_LABEL.ADD', { ns: 'common' })}
        saveLoading={uploadLoading}
      >
        <UploadFileAndDocument acceptedFileExtenstion=".xlsx,.xls" showTitleField={false} variant="asset" ref={uploadDocRef} />
      </BombiixModal>
    </>
  );
}

/**
 * Maps the supplier slice this page reads.
 * @param {SupplierStoreState} state - Root store state.
 * @returns {StateProps} The mapped props.
 */
const mapStateToProps = ({ SuppliersDetails, UserDetails }: SupplierStoreState): StateProps => {
  const { suppliersList, allSupplierTags } = SuppliersDetails;
  const { userInfo } = UserDetails;

  return {
    suppliersList,
    userInfo,
    allSupplierTags,
  };
};

const mapStateToDispatch = {
  delete_supplier: deleteSupplier,
  getProductAssociatesAction,
  fetchSupplierListAction,
  fetchSingleSupplierDetailsAction,
  supplierSuggestSwitchAction,
  integrateSupplierAction,
} as unknown as DispatchProps;

export default connect<StateProps, DispatchProps, OwnProps, SupplierStoreState>(mapStateToProps, mapStateToDispatch)(Supplier);
